<template>
  <v-container style="position: relative" fluid>
    <v-overlay :dark="false" v-model="overlayProcessing" opacity="0.1" absolute><v-progress-circular size="70" color="primary"
        indeterminate /></v-overlay>
    <v-row align="center" justify="center">
      <v-col v-if="member.rol === 'PENDING'" cols="12">
        <h3 class="text-center">{{ $t('noMemberYet', { name: member.user.firstName }) }}</h3>
      </v-col>
      <v-col v-else-if="member.rol !== 'PENDING'" class="d-flex align-center mb-n3" cols="3">
        <p class="mt-0 mb-0">{{ $t('prependTitle') }}</p>
        <SwisetSelect class="Accounts" ref="Accounts" :allOption="true"
          :options="memberAccounts.map(acc => ({ value: Number(acc.id), text: `${acc.identifier} - ${acc.broker.name.substring(0, 10)}...` }))"
          label="Broker Accounts" :placeholder=this.$i18n.messages[this.$i18n.locale].allBrokers :type="1"
          v-model="accountSelected" :changeEvent="accountChanged"></SwisetSelect>
      </v-col>

      <v-col v-if="member.rol !== 'PENDING'" style="border-left: solid 1px rgba(88, 90, 10, 0.2)" cols="9">
        <h3 v-if="analytics === null" class="text-center">{{ $t('noAnalyticsFound') }}</h3>
        <v-row v-else align="center" justify="center">
          <v-col v-bind:key="ratio" v-for="ratio in ratios">
            <h3 class="text-center" :style="`color: ${getRatioColor(ratio)}`">{{ getRatio(ratio) }}</h3>
            <p style="font-size: 14px;" class="text-center my-0">{{ getRatioName(ratio) }}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SwisetSelect from '../../../components/comp-base/SwisetSelect.vue';
import BrokerRepository from '../../../repositories/brokerAccount';
import JournalRepository from '../../../repositories/journal';
import Moods from "../../Journal/moods";

export default {
  props: {
    member: Object,
  },
  name: "ClubMemberPerformance",
  data() {
    return {
      overlayProcessing: false,
      analytics: null,
      memberAccounts: [],
      accountSelected: '',
      ratios: [
        'Winning Ratio',
        'Risk/Reward Ratio',
        'Swiset Ratio',
        'Profit Factor',
        'Net Profit',
      ],
    };
  },
  watch: {
    member() {
      this.init();
    },
  },
  created() {
    if (this.member.rol !== 'PENDING')
      this.init();
  },
  methods: {
    init() {
      this.overlayProcessing = true;
      BrokerRepository.allBrokerAccountsOfExternalUser(this.member.user.id).then((response) => {
        if (response.status < 400) {
          this.memberAccounts = response.data;
          this.setDefaults();
          this.accountChanged();
        }
      });
    },
    setDefaults() {
      this.accountSelected = undefined;
    },
    accountChanged() {
      this.overlayProcessing = true;
      if(this.accountSelected == undefined)
        this.accountSelected = this.memberAccounts.map(acc => acc.id);
      // Dates
      let nowFilters = new Date();
      nowFilters.setDate(nowFilters.getDate() + 1);
      let fromFilters = new Date();
      fromFilters.setTime((fromFilters.getTime() - 2.628e+9));
      let filter = {
        allStrategies:true,
        userId: this.member.user.id,
        fromDate: fromFilters,
        toDate: nowFilters,
        side: 'All',
        mood: Moods.map(m => m.key),
        assets: this.$store.state.user.assets.map(asset => (asset.ticker)),
        brokerAccounts: this.accountSelected.map(id => Number(id)),
        result: 'All',
        strategy: ["-1"],
      };
      JournalRepository.analyticsSummaryOfExternalUser(filter).then((response) => {
        if (response.status < 400) {
          this.analytics = response.data.content[0];
          this.overlayProcessing = false;
        }
      });
    },
    getRatioName(ratio) {
      if (this.analytics != null) {
        switch (ratio) {
          case 'Profit Factor':
            return this.$t('ratios.profitFactor');
          case 'Winning Ratio':
            return this.$t('ratios.winning');
          case 'Swiset Ratio':
            return this.$t('ratios.swiset');
          case 'Risk/Reward Ratio':
            return this.$t('ratios.riskReward');
          case 'Net Profit':
            return this.$t('ratios.netProfit');
        }
      }
    },
    getRatio(ratio) {
      if (this.analytics != null) {
        switch (ratio) {
          case 'Profit Factor':
            return this.analytics.profitFactor.toFixed(2);
          case 'Winning Ratio':
            return `${(this.analytics.winRate * 100).toFixed(1)}%`;
          case 'Swiset Ratio':
            return this.analytics.swisetRatio.toFixed(2);
          case 'Risk/Reward Ratio':
            return `1 : ${this.analytics.riskReward.toFixed(2)}`;
          case 'Net Profit':
            return this.getNumber(this.analytics.netProfit);
        }
      }
    },
    getRatioColor(ratio) {
      if (this.analytics != null) {
        switch (ratio) {
          case 'Profit Factor':
            return (this.analytics.profitFactor > 1) ? 'var(--v-darkGreen-base)' : '#f14400';
          case 'Winning Ratio':
            return '#111111';
          case 'Swiset Ratio':
            return (this.analytics.swisetRatio > 1) ? 'var(--v-darkGreen-base)' : '#f14400';
          case 'Risk/Reward Ratio':
            return '#111111';
          case 'Net Profit':
            return (this.analytics.netProfit > 0) ? 'var(--v-darkGreen-base)' : '#f14400';
        }
      }
    },
    getNumber(number) {
      return (number > 1000 || number < -1000) ? `${(number / 1000).toFixed(2)}k` : (number.toFixed(2) * 1).toString();
    },
  },
  components: { SwisetSelect }
}
</script>



<style>
.v-data-table__wrapper{
  overflow: visible !important;
}
</style>
